import { AppState, FeedPageMumbaiAppState } from '../../../initialStateRegistration';
import {
    FeedPageMumbaiCommercialSection,
    FeedPageMumbaiMinorSections,
    FeedPageSectionNames,
} from './feedPageMumbai.initialState';
import { SECTION_NAMES } from '../../../../templates/templates.const';

export const getFeedPage = (state: AppState) => (state as FeedPageMumbaiAppState).template;

const getCommercialSection = (state: AppState) => getFeedPage(state)[SECTION_NAMES.COMMERCIAL_SECTION];

export const getSectionDataByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key];

export const getSectionArticlesByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key].articles;

export const getSectionTitleByKey = (key: FeedPageMumbaiCommercialSection) => (state: AppState) => getFeedPage(state)[key].sectionTitle;

export const getShowMorePaginationTextByKey = (key: FeedPageMumbaiMinorSections) => (state: AppState) => getFeedPage(state)[key].showMorePaginationText;

export const getShowMorePaginationURLByKey = (key: FeedPageMumbaiMinorSections) => (state: AppState) => getFeedPage(state)[key].showMorePaginationURL;

export const getSectionSubtitle = (state: AppState) => getCommercialSection(state).subtitle;

export const getSectionLogo = (state: AppState) => getCommercialSection(state).logo;

export const getSectionBackground = (state: AppState) => getCommercialSection(state).background;

export const getSectionLink = (state: AppState) => getCommercialSection(state).link;

export const getPagination = (state: AppState) => getFeedPage(state).pagination;

export const getMetadataDescription = (state: AppState) => getFeedPage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getFeedPage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getFeedPage(state).metadataImage;

export const getHreflangData = (state: AppState) => getFeedPage(state).hreflangData;
